import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirDiagnosticReports } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirDiagnosticReports.STARTED]: handleActionStart,
  [fetchFhirDiagnosticReports.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirDiagnosticReports.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.diagnosticReports,
  [clearCurrentPatient]: () => initialState,
});
